import axios from "axios";
import { API_URL, tenantId } from "src/constants/api.ts";

axios.defaults.baseURL = API_URL;
axios.defaults.withCredentials = true;
if (tenantId) {
  axios.defaults.headers.common["x-tenant-id"] = tenantId;
}
